module.exports = __webpack_public_path__ + "assets/img/home_banner3_bg.f4baac82.png";